// extracted by mini-css-extract-plugin
module.exports = {"btn":"Create_btn__3u24a","btn-dark":"Create_btn-dark__1jexD"};